/**
 * React component that is responsible for interpretting the content blocks
 *  in a Contentful ModalButton and rendering the appropriate component
 *
 * Copyright (c) 2020 Coursera
 * Author: Kelvin Nguyen
 */
import React from 'react'
import PropTypes from 'prop-types'
import ContentfulVideo from '../ContentfulVideo'
import { convertRichTextToComponent } from '../utils'

const ContentfulModalButton = ({ contentBlocks }) => {
  if (!contentBlocks) return null

  return contentBlocks.map((content) => {
    if (!content) return null

    const contentType = content.__typename
    const key = `modalButton-${content.id}`

    switch (contentType) {
      case 'ContentfulVideo':
        return (<ContentfulVideo key={key} {...content} />)
      case 'ContentfulRichText':
        return (
          <div className="py-sm px-md" key={key}>
            {convertRichTextToComponent(content.text, true)}
          </div>
        )
      default:
        return null
    }
  })
}

ContentfulModalButton.propTypes = {
  contentBlocks: PropTypes.array,
}

export default ContentfulModalButton
